import {Injectable} from '@angular/core';
import {UATYPE} from './static-data/ua-type';
import { UaTypeMap } from './ua-type.model';

interface UaObject {
  uaPath: string;
  uaLabel: string;
}

@Injectable({providedIn: 'root'})
export class UaTypeService {
  getUaType(type: string): UaObject {
    const uatype = UATYPE as UaTypeMap;
    return {
      uaPath: uatype.path[type],
      uaLabel: uatype.label[type],
    };
  }
}
